<div [ngClass]="{ wrap: wrapContent }">
  <div class="insurance-info-container">
    <!-- Header -->
    <div class="insurance-header print-header" *ngIf="payload.properties.text?.value">
      <div class="header">
        <div class="title">{{ payload?.properties?.text?.value }}</div>
        <span class="message">* populated from PatientNow</span>
      </div>
      <mat-divider></mat-divider>
    </div>

    <div class="insurance-info-content">
      <!-- Insurance Containers -->
      <div *ngFor="let insuranceContainer of getContainers()">
        <div
          *ngIf="insuranceContainer.value && insuranceContainer.items?.length"
          [id]="'insurance-container-' + insuranceContainer.name"
          class="insurance-container"
          [ngClass]="'insurance-' + getInsuranceType(insuranceContainer)"
        >
          <h2 class="insurance-title">{{ getInsuranceTitle(insuranceContainer) }}</h2>
          <mat-divider></mat-divider>

          <!-- insurance entries inside this container -->
          <ng-container
            *ngFor="
              let insuranceInfo of getEntries(insuranceContainer);
              let entryIdx = index;
              trackBy: trackByInsuranceIndex
            "
          >
            <ng-container *ngIf="insuranceInfo.value !== false">
              <div
                class="insurance-entry"
                [class.insurance-entry--first]="entryIdx === 0"
                [id]="'insurance-entry-' + (insuranceInfo.insurance_id || insuranceContainer.name + '-' + entryIdx)"
              >
                <h3 class="insurance-info-title">{{ insuranceInfo.title }}</h3>
                <button
                  *ngIf="!isPrinting && !isPreview && !isInstanceDesign"
                  type="button"
                  class="remove-insurance-btn"
                  (click)="removeInsurance(insuranceContainer.name, entryIdx)"
                  aria-label="Remove insurance"
                >
                  <rx-icon name="icon-close" class="remove-icon"></rx-icon>
                  <span>Remove</span>
                </button>
                <!-- groups of fields for THIS insurance entry -->
                <ng-container *ngFor="let group of insuranceInfo.items; let groupIdx = index">
                  <div
                    class="insurance-group mb20"
                    [class.insurance-group--first]="groupIdx === 0"
                    *ngIf="group.value !== false"
                  >
                    <h4 class="group-title">{{ getGroupTitle(group) }}</h4>

                    <div class="insurance-fields-grid">
                      <ng-container *ngFor="let field of group.items; let i = index">
                        <ng-container *ngIf="field.visible">
                          <div class="insurance-field" [ngClass]="getColumnClass(i, field)">
                            <!-- TEXT -->
                            <ng-container *ngIf="field.type === 'text'">
                              <div class="fb__label">
                                <span class="fb__label-content">
                                  <span>{{ field.title }}</span>
                                  <span class="required-mark" *ngIf="field.required"> * </span>
                                  <fb-scribe-suggestion-indicator
                                    [target]="field"
                                    variant="full"
                                  ></fb-scribe-suggestion-indicator>
                                  <fb-amendment-field-indicator
                                    [fieldKey]="getAmendmentFieldKey(insuranceContainer, entryIdx, groupIdx, field)"
                                  />
                                </span>
                              </div>
                              <div class="rel">
                                <input
                                  class="fb__input"
                                  type="text"
                                  [ngClass]="{
                                    'has-conflict': isConflicting(field) && mode !== 'kiosk' && !isPreview,
                                  }"
                                  [ngModel]="fieldValue(field)"
                                  (ngModelChange)="setFieldValue(field, $event); onFieldValueChange(field)"
                                  [attr.aria-label]="field.title"
                                />
                                <rx-icon
                                  *ngIf="isConflicting(field) && mode !== 'kiosk' && !isPreview"
                                  name="icon-warning-circle"
                                  class="conflict-icon"
                                  [title]="field.conflictTooltip"
                                  (click)="toggleTooltip($event)"
                                ></rx-icon>
                                <div
                                  class="field-error"
                                  *ngIf="isSubmitted && field.required && (!field.value || field.value === '')"
                                >
                                  {{ field.title }} is required
                                </div>
                              </div>
                            </ng-container>

                            <!-- DATE -->
                            <ng-container *ngIf="field.type === 'date'">
                              <div class="fb__label">
                                <span class="fb__label-content">
                                  <span>{{ field.title }}</span>
                                  <span class="required-mark" *ngIf="field.required"> * </span>
                                  <fb-scribe-suggestion-indicator
                                    [target]="field"
                                    variant="full"
                                  ></fb-scribe-suggestion-indicator>
                                  <fb-amendment-field-indicator
                                    [fieldKey]="getAmendmentFieldKey(insuranceContainer, entryIdx, groupIdx, field)"
                                  />
                                </span>
                              </div>
                              <div
                                class="fb__date-wrap"
                                [ngClass]="{
                                  'has-conflict': isConflicting(field) && mode !== 'kiosk' && !isPreview,
                                }"
                              >
                                <input
                                  class="fb__input"
                                  type="text"
                                  placeholder="MM/DD/YYYY"
                                  [ngClass]="{
                                    'has-conflict': isConflicting(field) && mode !== 'kiosk' && !isPreview,
                                  }"
                                  [matDatepicker]="picker"
                                  [ngModel]="fieldValue(field)"
                                  (ngModelChange)="setFieldValue(field, $event); onFieldValueChange(field)"
                                  [attr.aria-label]="field.title"
                                  (focus)="picker.open()"
                                />
                                <rx-icon
                                  *ngIf="isConflicting(field) && mode !== 'kiosk'"
                                  name="icon-warning-circle"
                                  class="conflict-icon"
                                  [title]="field.conflictTooltip"
                                  (click)="toggleTooltip($event)"
                                ></rx-icon>
                                <button
                                  type="button"
                                  class="fb-btn fb-btn--icon fb-btn--calendar"
                                  [ngClass]="{
                                    'has-conflict': isConflicting(field) && mode !== 'kiosk' && !isPreview,
                                  }"
                                  aria-label="Open calendar"
                                  (click)="picker.open()"
                                >
                                  <rx-icon name="icon-calendar2"></rx-icon>
                                </button>
                                <mat-datepicker #picker></mat-datepicker>
                                <div
                                  class="field-error"
                                  *ngIf="isSubmitted && field.required && (!field.value || field.value === '')"
                                >
                                  {{ field.title }} is required
                                </div>
                              </div>
                            </ng-container>

                            <!-- DROPDOWN -->
                            <ng-container *ngIf="field.type === 'dropdown'">
                              <div class="fb__label">
                                <span class="fb__label-content">
                                  <span>{{ field.title }}</span>
                                  <span class="required-mark" *ngIf="field.required"> * </span>
                                  <fb-scribe-suggestion-indicator
                                    [target]="field"
                                    variant="full"
                                  ></fb-scribe-suggestion-indicator>
                                  <fb-amendment-field-indicator
                                    [fieldKey]="getAmendmentFieldKey(insuranceContainer, entryIdx, groupIdx, field)"
                                  />
                                </span>
                              </div>
                              <div class="rel">
                                <!-- States Dropdown-->
                                <rx-states
                                  *ngIf="['state', 'ph_state'].includes(field.name)"
                                  [hidePlaceHolder]="this.isPrinting || this.isPreview"
                                  [field]="getDisplayField(field)"
                                  (modelChangeEmit)="onFieldValueChange(field)"
                                  [ngClass]="{
                                    'has-conflict': isConflicting(field) && mode !== 'kiosk' && !isPreview,
                                  }"
                                ></rx-states>
                                <rx-icon
                                  *ngIf="
                                    isConflicting(field) &&
                                    ['state', 'ph_state'].includes(field.name) &&
                                    mode !== 'kiosk' &&
                                    !isPreview
                                  "
                                  name="icon-warning-circle"
                                  class="conflict-icon conflict-icon-ng-select"
                                  [title]="field.conflictTooltip"
                                  (click)="toggleTooltip($event)"
                                ></rx-icon>
                                <!-- Insurance Company Dropdown -->
                                <ng-select
                                  *ngIf="field.name === 'company_code'"
                                  [ngClass]="{
                                    'has-conflict': isConflicting(field) && mode !== 'kiosk' && !isPreview,
                                  }"
                                  [items]="insurancePayers"
                                  bindLabel="Name"
                                  [compareWith]="compareInsurancePlans"
                                  [closeOnSelect]="true"
                                  [searchable]="true"
                                  [searchFn]="customSearchFn"
                                  [virtualScroll]="true"
                                  [loading]="isLoadingInsurancePlans"
                                  [clearable]="true"
                                  [minTermLength]="0"
                                  [bufferAmount]="20"
                                  [trackByFn]="trackByPayerId"
                                  dropdownPosition="auto"
                                  appendTo="body"
                                  [placeholder]="
                                    isPrinting || isPreview ? '' : field?.placeholder || 'Select Insurance Company'
                                  "
                                  [ngModel]="fieldValue(field)"
                                  (ngModelChange)="onInsuranceCompanyChange($event, field)"
                                  (scrollToEnd)="onScrollToEnd()"
                                  (open)="onDropdownOpen()"
                                  (search)="onSearch($event)"
                                >
                                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                    <div [innerHTML]="highlightMatch(item.Name, searchTerm)"></div>
                                  </ng-template>
                                  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                                    <div class="custom-header">
                                      <span *ngIf="searchTerm"> No insurance plans found for "{{ searchTerm }}" </span>
                                      <span
                                        *ngIf="!searchTerm && insurancePayers.length === 0 && !isLoadingInsurancePlans"
                                      >
                                        No insurance plans available
                                      </span>
                                      <span *ngIf="!searchTerm && insurancePayers.length > 0"> Type to search... </span>
                                    </div>
                                  </ng-template>
                                  <ng-template ng-loading-tmp>
                                    <div class="custom-header">
                                      <span>Loading insurance plans...</span>
                                    </div>
                                  </ng-template>
                                  <ng-template ng-footer-tmp>
                                    <div class="custom-header">
                                      <small *ngIf="!isLoadingMore && insurancePayers.length > 0">
                                        {{ insurancePayers.length }} plans loaded
                                        <span *ngIf="hasMorePages"> • Scroll for more </span>
                                      </small>
                                      <small *ngIf="isLoadingMore"> Loading more... </small>
                                    </div>
                                  </ng-template>
                                </ng-select>
                                <rx-icon
                                  *ngIf="
                                    isConflicting(field) &&
                                    field.name === 'company_code' &&
                                    mode !== 'kiosk' &&
                                    !isPreview
                                  "
                                  name="icon-warning-circle"
                                  class="conflict-icon conflict-icon-ng-select"
                                  [title]="field.conflictTooltip"
                                  (click)="toggleTooltip($event)"
                                  style="transform: translateY(-50%) translateX(-10px)"
                                ></rx-icon>
                                <ng-select
                                  *ngIf="!['company_code', 'state', 'ph_state'].includes(field.name)"
                                  [ngClass]="{
                                    'has-conflict': isConflicting(field) && mode !== 'kiosk' && !isPreview,
                                  }"
                                  [items]="field?.options || []"
                                  [bindLabel]="field?.optionLabelKey || 'title'"
                                  [bindValue]="field?.optionValueKey || 'value'"
                                  [closeOnSelect]="true"
                                  [searchable]="false"
                                  [placeholder]="isPrinting || isPreview ? '' : field?.placeholder"
                                  [ngModel]="fieldValue(field)"
                                  (ngModelChange)="setFieldValue(field, $event); onFieldValueChange(field)"
                                ></ng-select>
                                <rx-icon
                                  *ngIf="
                                    isConflicting(field) &&
                                    !['company_code', 'state', 'ph_state'].includes(field.name) &&
                                    mode !== 'kiosk' &&
                                    !isPreview
                                  "
                                  name="icon-warning-circle"
                                  class="conflict-icon conflict-icon-ng-select"
                                  [title]="field.conflictTooltip"
                                  (click)="toggleTooltip($event)"
                                ></rx-icon>
                                <div
                                  class="field-error"
                                  *ngIf="isSubmitted && field.required && (!field.value || field.value === '')"
                                >
                                  {{ field.title }} is required
                                </div>
                              </div>
                            </ng-container>

                            <!-- FALLBACK -->
                            <ng-container
                              *ngIf="field.type !== 'text' && field.type !== 'date' && field.type !== 'dropdown'"
                            >
                              <input
                                class="fb__input"
                                type="text"
                                [formControlName]="field.key || field.name"
                                (input)="onFieldValueChange(field)"
                              />
                            </ng-container>
                          </div>
                        </ng-container>
                      </ng-container>
                    </div>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>

          <!-- required hint -->
          <div *ngIf="payload.properties.required?.value && isSubmitted && !isValid()" class="hint-required">
            This field is required
          </div>
        </div>
      </div>
      <ng-container *ngIf="!isPrinting && !isPreview">
        <!-- Add Primary Insurance button when primary is hidden -->
        <ng-container *ngIf="!hasPrimaryInsurance()">
          <mat-divider class="dash"></mat-divider>
          <div>
            <rx-button
              class="white stretch mb10 border-blue"
              (click)="addPrimaryInsurance()"
              (keydown)="addPrimaryInsurance()"
            >
              <rx-icon class="mr15" name="icon-circle-plus-2"></rx-icon>
              Add Primary Insurance
            </rx-button>
          </div>
        </ng-container>

        <mat-divider class="dash"></mat-divider>
        <div>
          <rx-button
            class="white stretch mb10 border-blue"
            (click)="addSecondaryInsurance()"
            (keydown)="addSecondaryInsurance()"
          >
            <rx-icon class="mr15" name="icon-circle-plus-2"></rx-icon>
            Add Secondary Insurance
          </rx-button>
        </div>

        <mat-divider class="dash"></mat-divider>
        <div>
          <rx-button
            class="white stretch mb10 border-blue"
            (click)="addTertiaryInsurance()"
            (keydown)="addTertiaryInsurance()"
          >
            <rx-icon class="mr15" name="icon-circle-plus-2"></rx-icon>
            Add Tertiary Insurance
          </rx-button>
        </div>
      </ng-container>
    </div>
  </div>
</div>
